import React from 'react';
import { adminChefName, adminClientName } from '../../masks';
import { withServiceCalendar } from '../admin/ServiceCalendarContext';

const ServicesCalendarAgendaEvent = props => {
  const { service } = props.event;
  const fullName = adminClientName(service.client)
  const chefs = service.invited_chefs
    .filter(chef => chef.status === 'accepted')
    .map(({ chef }) => adminChefName(chef))

  const handleClick = service => props.onServiceSelect(service);

  return (
    <div
      className={`service-calendar__event --${
        props.event.service.service_type
      }`}
    >
      {service.name && (
        <div className="service-calendar__name">{service.name}</div>
      )}
      <div className="service-calendar__client">{fullName}</div>
      {chefs.map((chef, key) => (
        <div key={key} className="service-calendar__chef">
          {chef}
        </div>
      ))}
      <div onClick={() => handleClick(service)} className="a--blue">
        View
      </div>
    </div>
  );
};
//<Link to={`/admin/service/${service.id}`} className="a--blue">View</Link>

export default withServiceCalendar(ServicesCalendarAgendaEvent);



// WEBPACK FOOTER //
// ./src/components/services/ServicesCalendarAgendaEvent.js